// client/src/branding/agoc.ts
// Branding configuration for the AGOC School neutral default tenant.
// Used as the fallback when the hostname does not match any known tenant.

import type { TenantBranding } from './types';

export const agocBranding: TenantBranding = {
  id: 'agoc',
  name: 'AGOC School',
  appTitle: 'AGOC School',
  logo: '/branding/agoc/logo.png',
  favicon: '/branding/agoc/favicon.png',
  loginLogo: '/branding/agoc/logo.png',
  loginImage: '',
  loginTitle: 'Sistema de Gestión Académica con IA integrada',
  loginSubtitle: 'Plataforma para profesores, alumnos y personal administrativo',
  sidebarTitle: 'AGOC School',
  footerText: 'AGOC School - Sistema de Gestión Académica',
  aiAssistantName: 'Asistente IA',
  domains: [
   // 'localhost',
    'platform.agoc-school.com',
    'agoc-school.com',
  ],
};
